import { ConfirmCancelModal } from '@/shared/components/ConfirmCancelModal'

interface Props {
  open: boolean
  confirming: boolean
  onClose: () => void
  onConfirm: () => void
}

export function DeleteDraftInstrumentDialog({
  open,
  confirming,
  onClose,
  onConfirm,
}: Readonly<Props>) {
  return (
    <ConfirmCancelModal
      open={open}
      iconVariant="delete"
      headline="Do you want to remove this draft survey?"
      bodyLines={[
        'This will permanently remove this draft survey from the system.',
        "You can't undo this action.",
      ]}
      stayLabel="Cancel"
      confirmLabel="Continue"
      confirmTone="danger"
      confirmDisabled={confirming}
      onStay={onClose}
      onConfirm={onConfirm}
      dialogTestId="delete-draft-instrument-dialog"
      stayTestId="delete-draft-instrument-cancel"
      confirmTestId="delete-draft-instrument-confirm"
    />
  )
}
